/**
 * メルマガフォーム拡張
 *
 * 完了後にフォームまでスクロール出来ないケースがあるため
 * 代わりにtoastで登録完了メッセージを表示
 */

import Snackbar from "node-snackbar";

export default {
    init: function () {
        //const hasHash = window.location.hash == "#ContactFooter";
        const hasSearch = window.location.search.includes('contact%5Btags%5D=');
        const hasError = !!window['ContactFooterError'];

        if (hasSearch && !hasError) {
            window.addEventListener("load", function () {
                Snackbar.show({
                    pos: 'top-right',
                    textColor: '#FFF',
                    backgroundColor: '#101319',
                    text: 'ニュースレターへのご登録ありがとうございます',
                    showAction: false,
                    // actionTextColor: '#EEE',
                    // actionText: '×',
                });
            });
        }
    }
};
